import { Tabs, TablePagination } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { adminTab, sortOrder } from '~/types/enum';
import { admin } from './Admin.style';
import {
  ROWS_PER_PAGE_OPTIONS,
  tabs,
  initTabsCategory,
} from './Admin.constant';
import { TSort } from '~/types/common.type';
import { ResourceFilter } from '~/components/Admin/ResourceFilter';
import { InternetResourceFilter } from '~/components/Admin/InternetResourceFilter';
import { ResourceTable } from '~/components/Admin/ResourceTable';
import { InternetResourceTable } from '~/components/Admin/InternetResourceTable';
import { RecordTable } from '~/components/Admin/RecordTable';
// import { TSearchCondition } from '~/store/resource/resource.type';
import { resetSearchCondition, setSearchCondition } from '~/store/resource';
import {
  setSearchCondition as setSearchInternetCondition,
  resetSearchCondition as resetSearchInternetCondition,
} from '~/store/internetResource';
import { setRecordSearchCondition } from '~/store/record';
import { useAppDispatch } from '~/store';
import { useSelector } from 'react-redux';
import { getterAdminResourceFilter } from '~/store/resource/resourceGetter';
import { getterAdminRecordFilter } from '~/store/record/recordGetter';
import { getterInternetResourceFilter } from '~/store/internetResource/internetResourceGetter';

export const Admin = () => {
  const dispatch = useAppDispatch();
  const [, setSearchParams] = useSearchParams();
  const [tab, setTab] = useState<adminTab>(tabs[0]);
  const [totalPageCount, setTotalPageCount] = useState(0);

  const getAdminResourceFilter = (tabType: adminTab) => {
    switch (tabType) {
      case adminTab.record:
        return getterAdminRecordFilter;
      case adminTab.InternetResource:
        return getterInternetResourceFilter;
      default:
        return getterAdminResourceFilter;
    }
  };
  const { pagination } = useSelector(getAdminResourceFilter(tab));
  const [sort, setSort] = useState<TSort<string>>({
    property:
      tab === adminTab.school || tab === adminTab.cramSchools
        ? 'fileUploadTime'
        : 'categories',
    order: sortOrder.DESC,
  });

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: adminTab,
  ) => {
    const category =
      initTabsCategory[newValue as keyof typeof initTabsCategory];
    setTab(newValue);
    setSearchParams({ tab: newValue });
    if (tab === adminTab.school || tab === adminTab.cramSchools) {
      dispatch(
        resetSearchCondition({
          type: 'admin',
          categories: category,
        }),
      );
    } else if (tab === adminTab.InternetResource) {
      dispatch(
        resetSearchInternetCondition({
          type: 'admin',
          category: 'all',
        }),
      );
    }
  };

  const handleSort = (property: string) => {
    setSort(prev =>
      prev.property === property
        ? {
            ...prev,
            order:
              prev.order === sortOrder.ASC ? sortOrder.DESC : sortOrder.ASC,
          }
        : { ...prev, property },
    );
  };

  useEffect(() => {
    dispatch(
      setSearchCondition({
        sort: `${sort.order === sortOrder.ASC ? '' : '-'}${sort.property}`,
      }),
    );
  }, [sort]);

  return (
    <>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        TabIndicatorProps={{
          style: { backgroundColor: 'info.main' },
        }}
      >
        {tabs.map(item => (
          <admin.InfoTab key={item} label={item} value={item} />
        ))}
      </Tabs>
      {(tab === adminTab.school || tab === adminTab.cramSchools) && (
        <ResourceFilter tab={tab} />
      )}
      {tab === adminTab.InternetResource && <InternetResourceFilter />}
      <admin.ContentContainer>
        {(tab === adminTab.school || tab === adminTab.cramSchools) && (
          <ResourceTable
            sort={sort}
            handleSort={handleSort}
            tab={tab}
            setTotalPageCount={setTotalPageCount}
          />
        )}
        {tab === adminTab.InternetResource && (
          <InternetResourceTable
            sort={sort}
            handleSort={handleSort}
            tab={tab}
            setTotalPageCount={setTotalPageCount}
          />
        )}
        {tab === adminTab.record && (
          <RecordTable
            sort={sort}
            handleSort={handleSort}
            setTotalPageCount={setTotalPageCount}
          />
        )}
        <TablePagination
          component="div"
          count={totalPageCount}
          page={pagination.page ? pagination.page - 1 : 0}
          onPageChange={(_event, newValue) => {
            if (tab === adminTab.school || tab === adminTab.cramSchools) {
              dispatch(setSearchCondition({ page: newValue + 1 }));
            } else if (tab === adminTab.InternetResource) {
              dispatch(setSearchInternetCondition({ page: newValue + 1 }));
            } else if (tab === adminTab.record) {
              dispatch(setRecordSearchCondition({ page: newValue + 1 }));
            }
          }}
          rowsPerPage={pagination.pageSize || 0}
          onRowsPerPageChange={event => {
            if (tab === adminTab.school || tab === adminTab.cramSchools) {
              dispatch(
                setSearchCondition({
                  pageSize: Number(event.target.value),
                  page: 1,
                }),
              );
            } else if (tab === adminTab.InternetResource) {
              dispatch(
                setSearchInternetCondition({
                  pageSize: Number(event.target.value),
                  page: 1,
                }),
              );
            } else if (tab === adminTab.record) {
              dispatch(
                setRecordSearchCondition({
                  pageSize: Number(event.target.value),
                  page: 1,
                }),
              );
            }
          }}
          rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
          labelRowsPerPage="每筆列數"
        />
      </admin.ContentContainer>
    </>
  );
};
